<template>
  <div>
    <!-- list -->
    <div class="p-6 pt-0">
      <div v-if="!isAddModalShow && !isEditModalShow">
        <vs-table
          id="donation-list"
          class="vs-con-loading__container"
          stripe
          :sst="true"
          maxHeight="800px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          :total="donationFilteredCount"
          :max-items="length"
          :data="donationRecords"
        >
          <template slot="header">
            <div class="mb-2 flex items-center">
              <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                  <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">
                        {{ page * length - (length - (donationFilteredCount && 1)) || 0 }}
                        -
                        {{ donationFilteredCount - page * length > 0 ? page * length : donationFilteredCount }}
                        of {{ donationTotal || 0 }}
                      </span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="handleChangeLength(10)">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(20)">
                        <span>20</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(50)">
                        <span>50</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(100)">
                        <span>100</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
              <vs-button v-if="checkPermissionSlug(['gurudwara_donation_create'])" @click="toggleAddModal" color="primary" size="default" style="padding: 12px 30px">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add {{ module_name }}</vs-button
              >

              <vs-button
                v-if="checkPermissionSlug(['gurudwara_donation_delete']) && selectedRows.length"
                @click="bulkDeleteRecords"
                color="danger"
                size="default"
                style="padding: 12px 30px; margin-left: 10px"
              >
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" /> Delete Selected
              </vs-button>
            </div>
          </template>

          <template slot="thead">
            <vs-th v-if="checkPermissionSlug(['gurudwara_donation_delete'])">
              <vs-checkbox :value="isAllSelected" :indeterminate="isSomeSelected" @change="toggleSelectAll" />
            </vs-th>
            <vs-th>Sr#</vs-th>
            <vs-th>Title</vs-th>
            <vs-th>Account Name</vs-th>

            <vs-th v-if="checkPermissionSlug(['gurudwara_donation_edit', 'gurudwara_donation_create', 'gurudwara_donation_delete', 'gurudwara_donation_view'])">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td class="flex justify-start" v-if="checkPermissionSlug(['gurudwara_donation_delete'])">
                <vs-checkbox :value="selectedRows.includes(tr._id)" @change="toggleRowSelection(tr._id)" />
              </vs-td>
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer" v-if="checkPermissionSlug(['gurudwara_donation_edit'])" @click.stop="toggleEditModal(tr._id)" v-tooltip="{ content: `Edit ${tr.title}` }">{{
                  tr.title || '-'
                }}</span>
                <span v-else>{{ tr.title || '-' }}</span>
              </vs-td>
              <vs-td class="text-left">
                <span>{{ tr.account_name || '-' }}</span>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['gurudwara_donation_edit', 'gurudwara_donation_create', 'gurudwara_donation_delete', 'gurudwara_donation_view'])">
                <div class="inline-flex">
                  <vx-tooltip v-if="checkPermissionSlug(['gurudwara_donation_create'])" :text="`${module_name} Clone`">
                    <feather-icon :icon="'CopyIcon'" svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" @click.stop="openCloneModal(tr._id)" />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="checkPermissionSlug(['gurudwara_donation_edit']) || checkPermissionSlug(['gurudwara_donation_view'])"
                    :text="`${module_name} Details ${checkPermissionSlug(['gurudwara_donation_edit']) ? 'Edit' : 'View'}`"
                  >
                    <feather-icon
                      @click.stop="toggleEditModal(tr._id)"
                      :icon="checkPermissionSlug(['gurudwara_donation_edit']) ? 'EditIcon' : 'EyeIcon'"
                      svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer"
                    />
                  </vx-tooltip>
                  <vx-tooltip v-if="checkPermissionSlug(['gurudwara_donation_delete'])" :text="`${module_name} Delete`">
                    <feather-icon @click.stop="deleteRecord(tr._id)" icon="TrashIcon" svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <!-- Custom Pagination -->
        <vs-pagination v-if="donationFilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-8"></vs-pagination>
      </div>

      <!-- Add modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isAddModalMounted" :showModal.sync="isAddModalShow" :action_name="'Add'" :clonedData="clonedData" />

      <!-- Edit modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isEditModalMounted" :showModal.sync="isEditModalShow" :selectedRecordId="selectedRecordId" :action_name="'Update'" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import actionModal from './action'
import moment from 'moment'

export default {
  name: 'DonationList',

  components: { actionModal },
  /** Data */
  data: () => ({
    selectedRows: [],
    order: [],
    length: 100,
    page: 1,
    search: '',
    form: {
      title: '',
      type: 'Details'
    },
    module_name: 'Donation',

    // Add modal
    isAddModalMounted: false,
    isAddModalShow: false,
    clonedData: null,

    // Edit modal
    isEditModalMounted: false,
    isEditModalShow: false,
    selectedRecordId: null
  }),

  /** computed */
  computed: {
    ...mapState('gurudwara', ['donationRecords', 'donationTotal', 'donationFilteredCount', 'donationListLoading', 'createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    validateForm() {
      return !this.errors.any()
    },
    totalPages() {
      return Math.ceil(this.donationFilteredCount / this.length)
    },
    /** Check if all checkboxes are selected */
    isAllSelected() {
      return this.selectedRows.length === this.donationRecords.length && this.donationRecords.length > 0
    },

    /** Check if some checkboxes are selected (for indeterminate state) */
    isSomeSelected() {
      return this.selectedRows.length > 0 && this.selectedRows.length < this.donationRecords.length
    }
  },

  /** Functions */
  methods: {
    ...mapActions('gurudwara', {
      get: 'donationGet',
      delete: 'donationDelete',
      create: 'donationCreate'
    }),

    /** Toggle Select All */
    toggleSelectAll() {
      if (this.selectedRows.length === this.donationRecords.length) {
        this.selectedRows = []
      } else {
        this.selectedRows = this.donationRecords.map((tr) => tr._id)
      }
    },

    /** Toggle Individual Row Selection */
    toggleRowSelection(id) {
      const index = this.selectedRows.indexOf(id)
      if (index === -1) {
        this.selectedRows.push(id)
      } else {
        this.selectedRows.splice(index, 1)
      }
    },

    /** Bulk Delete */
    bulkDeleteRecords() {
      if (this.selectedRows.length === 0) return

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Bulk Delete`,
        text: `Are you sure you want to delete ${this.selectedRows.length} records?`,
        accept: () => this.deleteMultipleRecords(),
        acceptText: 'Delete'
      })
    },

    async openCloneModal(id) {
      try {
        // Fetch existing donation data
        const response = await this.$store.dispatch('gurudwara/donationShow', id)
        const originalData = response.data.data
        const { _id, is_active, createdAt, updatedAt, image, qr_image, ...clonedData } = originalData
        this.clonedData = { ...clonedData, title: `${originalData.title} - Copy` }

        // Prepare cloned data
        this.isAddModalMounted = true
        this.isAddModalShow = true
        this.selectedRecordId = null
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to clone donation.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** Bulk Delete API Call */
    async deleteMultipleRecords() {
      try {
        const { message } = await this.$store.dispatch('gurudwara/donationBulkDelete', { donation: this.selectedRows })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.selectedRows = []
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** Donation Popup */
    toggleAddModal() {
      this.isAddModalMounted = true
      this.isAddModalShow = true
      this.selectedRecordId = null
      this.clonedData = null
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search,
        gurudwara: this.$route.params.id
      })
    },

    toggleEditModal(id) {
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecordId = id
    },

    /** Delete Confirmation*/
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete  API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** create Donation Heading */
    async createDonationHeading() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        this.form.gurudwara = this.$route.params.id
        const { message } = await this.create(this.form)
        this.getData()
        this.form = {}
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    clearDateRange() {
      this.getData() // Optionally call your data fetch function to reset the data
    }
  },

  /** Watchers */
  watch: {
    donationListLoading() {
      if (this.donationListLoading) {
        this.$vs.loading({
          container: '#donation-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#donation-list > .con-vs-loading')
      }
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#invite-gurudwara',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#invite-gurudwara > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    },
    isAddModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddModalMounted = false
          }, 0)
        }
      }
    },

    // Edit modal
    isEditModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditModalMounted = false
          }, 0)
        }
      }
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
<style>
.input-group .feather-icon {
  position: absolute;
  bottom: 30px;
  left: 85%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
